var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeAClass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 2.5625C31.2344 0.609375 34.4375 0.609375 36.3906 2.5625L39.4375 5.60938C41.3906 7.5625 41.3906 10.7656 39.4375 12.7188L35.6875 16.4688L25.5312 6.3125L29.2812 2.5625ZM23.7344 8.10938L33.8906 18.2656L15.6875 36.4688C14.9062 37.25 13.8906 37.875 12.7969 38.1875L3.34375 41C2.71875 41.1562 2.01562 41 1.54688 40.4531C1 39.9844 0.84375 39.2812 1.07812 38.6562L3.8125 29.2031C4.125 28.1094 4.75 27.0938 5.53125 26.3125L23.7344 8.10938Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAClass);
export default __webpack_public_path__ + "static/media/take_a_class.8f1771ff10bbd1460e5b352be5c7f306.svg";
export { ForwardRef as ReactComponent };